import { render, staticRenderFns } from "./ResolvedPractitionerComplaints.vue?vue&type=template&id=9094093a&scoped=true&"
import script from "./ResolvedPractitionerComplaints.vue?vue&type=script&lang=js&"
export * from "./ResolvedPractitionerComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9094093a",
  null
  
)

export default component.exports